var map = {
	"./airtm-dark.png": "a8b9",
	"./airtm.png": "2072",
	"./andbank.png": "31e7",
	"./arch-dark.png": "966a",
	"./arch.png": "968c",
	"./auriga.png": "ee69",
	"./bankinter.png": "3736",
	"./bbva-dark.png": "da01",
	"./bbva.png": "1b7b",
	"./binance.png": "4126",
	"./bingx.png": "6475",
	"./bit2me.png": "4829",
	"./bitbox-dark.png": "5d03",
	"./bitbox.png": "4d9f",
	"./bitget.png": "5bd1",
	"./bitpanda-dark.png": "878a",
	"./bitpanda.png": "6fbb",
	"./bitso.png": "18f4",
	"./bitstamp-dark.png": "dbda",
	"./bitstamp.png": "9929",
	"./bittrex-dark.png": "858f",
	"./bittrex.png": "33a8",
	"./bitvavo-dark.png": "020d",
	"./bitvavo.png": "37e3",
	"./buxzero-dark.png": "d0c1",
	"./buxzero.png": "50d1",
	"./caixabank-dark.png": "0faa",
	"./caixabank.png": "65e7",
	"./clicktrade.png": "1c53",
	"./cobas.png": "a98a",
	"./coinbase.png": "7334",
	"./criptan-dark.png": "a7cc",
	"./criptan.png": "192c",
	"./cryptocom-dark.png": "ca31",
	"./cryptocom.png": "61ca",
	"./degiro-dark.png": "5144",
	"./degiro.png": "a335",
	"./equatePlus.png": "4bbc",
	"./etoro-dark.png": "e3e5",
	"./etoro.png": "440a",
	"./etrade-dark.png": "d84f",
	"./etrade.png": "f57c",
	"./exante-dark.png": "a6f6",
	"./exante.png": "492a",
	"./finizens.png": "bf67",
	"./freedom24-dark.png": "b9a2",
	"./freedom24.png": "6120",
	"./gemini-dark.png": "917e",
	"./gemini.png": "bf93",
	"./hapi-dark.png": "ed80",
	"./hapi.png": "68f4",
	"./heytrade-dark.png": "e2ce",
	"./heytrade.png": "2648",
	"./huobi.png": "0929",
	"./ibkr-dark.png": "4d01",
	"./ibkr.png": "268e",
	"./ii-dark.png": "841f",
	"./ii.png": "20b8",
	"./inbestme-dark.png": "4ad8",
	"./inbestme.png": "3d38",
	"./indexa.png": "e47f",
	"./ing-dark.png": "ca30",
	"./ing.png": "d945",
	"./ironia.png": "0bb5",
	"./kraken.png": "635c",
	"./kucoin.png": "3ca0",
	"./kutxabank-dark.png": "b782",
	"./kutxabank.png": "71f1",
	"./ledger-dark.png": "86ed",
	"./ledger.png": "169d",
	"./myinvestor-dark.png": "9124",
	"./myinvestor.png": "347f",
	"./n26-dark.png": "a9b7",
	"./n26.png": "a903",
	"./nexo.png": "e79a",
	"./ninetynine.png": "430e",
	"./openbank-dark.png": "fe3b",
	"./openbank.png": "796b",
	"./perCapital-dark.png": "4521",
	"./perCapital.png": "cc61",
	"./plus500.png": "8584",
	"./renta4-dark.png": "f759",
	"./renta4.png": "134e",
	"./revolut-dark.png": "3f9a",
	"./revolut.png": "68de",
	"./robinhood.png": "e17d",
	"./sabadell-dark.png": "36b6",
	"./sabadell.png": "7eda",
	"./santander.png": "17a6",
	"./saxobank.png": "982d",
	"./scalable-dark.png": "b5f2",
	"./scalable.png": "85d0",
	"./schwab.png": "a67e",
	"./selfbank.png": "9057",
	"./swissquote.png": "7de6",
	"./tastytrade-dark.png": "925a",
	"./tastytrade.png": "5f97",
	"./tradeRepublic-dark.png": "e961",
	"./tradeRepublic.png": "86b0",
	"./tradestation.png": "1120",
	"./trading212-dark.png": "98f9",
	"./trading212.png": "d984",
	"./trustwallet.png": "d780",
	"./unicaja-dark.png": "8e59",
	"./unicaja.png": "5f80",
	"./vanguard.png": "9edd",
	"./vivid.png": "2885",
	"./vtmarkets-dark.png": "5b46",
	"./vtmarkets.png": "0280",
	"./xtb-dark.png": "8da5b",
	"./xtb.png": "ccf4",
	"./xtb_old.png": "11dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cac";